import React, { useState, useEffect, useRef } from 'react';

function App() {
  // Default limba română
  const [currentLang, setCurrentLang] = useState('ro');
  const [infinityAmount, setInfinityAmount] = useState(0);
  const [infinityCycles, setInfinityCycles] = useState(0);
  const [magicAmount, setMagicAmount] = useState(0);
  const [happyAmount, setHappyAmount] = useState(0);
  const [happyCollected, setHappyCollected] = useState(0);
  const [showJackpots, setShowJackpots] = useState(true);
  const [showLangDropdown, setShowLangDropdown] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [soundPlayed, setSoundPlayed] = useState(false);
  const [formFocused, setFormFocused] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [leprechauns, setLeprechauns] = useState([]);
  const [collectedRewards, setCollectedRewards] = useState([]);
  const [showSignLeprechaun, setShowSignLeprechaun] = useState(false);
  const [signLeprechaunPos, setSignLeprechaunPos] = useState({ x: 0, y: 0 });
  const [signLeprechaunScale, setSignLeprechaunScale] = useState(1);
  const [showJackpotWin, setShowJackpotWin] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);
  
  // Poziții jackpoturi
  const [infinityPos, setInfinityPos] = useState({ x: 20, y: '50%', left: 20, top: '50%' });
  const [magicPos, setMagicPos] = useState({ x: 'auto', y: '50%', right: 20, top: '50%' });
  const [happyPos, setHappyPos] = useState({ x: 20, y: 'auto', bottom: 80 });
  const [isMoving, setIsMoving] = useState({ infinity: false, magic: false, happy: false });
  
  const targetAmount = 1000000;
  
  // Detectare mobil
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  // ========== STRUCTURED DATA PENTRU GOOGLE (SEO) ==========
  useEffect(() => {
    const scriptProduct = document.createElement('script');
    scriptProduct.type = 'application/ld+json';
    scriptProduct.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Magic Games - Domeniu Casino Online",
      "description": "Fost cazinou online cu tradiție, disponibil pentru vânzare. Domeniu premium cu istoric și autoritate în domeniul jocurilor de noroc online.",
      "url": "https://magicgames.ro",
      "brand": {
        "@type": "Brand",
        "name": "Magic Games"
      },
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "EUR",
        "availability": "https://schema.org/InStock",
        "seller": {
          "@type": "Organization",
          "name": "Magic Games Owner"
        }
      }
    });
    document.head.appendChild(scriptProduct);
    
    const scriptWebsite = document.createElement('script');
    scriptWebsite.type = 'application/ld+json';
    scriptWebsite.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Magic Games",
      "url": "https://magicgames.ro",
      "description": "Fost cazinou online de vânzare - domeniu premium pentru casino online",
      "inLanguage": ["ro", "en", "de", "fr", "it"],
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://magicgames.ro/#contact-form-section",
        "query-input": "required name=offer"
      }
    });
    document.head.appendChild(scriptWebsite);
    
    return () => {
      document.head.removeChild(scriptProduct);
      document.head.removeChild(scriptWebsite);
    };
  }, []);
  
  // ========== VIDEOURI CARE SE RIDICĂ AUTOMAT ==========
  useEffect(() => {
    const interval = setInterval(() => {
      if (!formFocused && !formSubmitted) {
        const randomVideo = Math.floor(Math.random() * 4) + 1;
        setActiveVideo(randomVideo);
        
        setTimeout(() => {
          setActiveVideo(null);
        }, 5000);
      }
    }, 10000);
    
    return () => clearInterval(interval);
  }, [formFocused, formSubmitted]);
  
  // ========== JACKPOTURI HAOTICE CU MIȘCARE ==========
  useEffect(() => {
    // Infinity Jackpot - creștere
    const infinityInterval = setInterval(() => {
      setInfinityAmount(prev => {
        if (prev >= targetAmount) {
          const winAmount = prev;
          setShowJackpotWin({ type: 'infinity', name: '🌊 INFINITY JACKPOT', amount: winAmount });
          setTimeout(() => setShowJackpotWin(null), 4000);
          setInfinityCycles(c => c + 1);
          setTimeout(() => setInfinityAmount(0), 1000);
          return targetAmount;
        }
        const randomMultiplier = Math.random() * 2 + 0.3;
        const increment = Math.random() * 8000 * randomMultiplier + 1000;
        return Math.min(prev + increment, targetAmount);
      });
    }, 150);
    
    // Magic Gold Jackpot
    const magicInterval = setInterval(() => {
      setMagicAmount(prev => {
        if (prev >= targetAmount) {
          const winAmount = prev;
          setShowJackpotWin({ type: 'magic', name: '🔥 MAGIC GOLD JACKPOT', amount: winAmount });
          setTimeout(() => setShowJackpotWin(null), 4000);
          setTimeout(() => setMagicAmount(0), 1000);
          return targetAmount;
        }
        const randomMultiplier = Math.random() * 2 + 0.3;
        const increment = Math.random() * 7000 * randomMultiplier + 800;
        return Math.min(prev + increment, targetAmount);
      });
    }, 180);
    
    // Happy Hour Jackpot
    const happyInterval = setInterval(() => {
      setHappyAmount(prev => {
        if (prev >= targetAmount) {
          const winAmount = prev;
          setShowJackpotWin({ type: 'happy', name: '🎉 HAPPY HOUR JACKPOT', amount: winAmount });
          setTimeout(() => setShowJackpotWin(null), 4000);
          setTimeout(() => setHappyAmount(0), 1000);
          return targetAmount;
        }
        const randomMultiplier = Math.random() * 2 + 0.3;
        const increment = Math.random() * 10000 * randomMultiplier + 1500;
        return Math.min(prev + increment, targetAmount);
      });
    }, 120);
    
    return () => {
      clearInterval(infinityInterval);
      clearInterval(magicInterval);
      clearInterval(happyInterval);
    };
  }, []);
  
  // ========== JACKPOTURI SE PLIMBĂ ==========
  useEffect(() => {
    const moveInfinity = () => {
      if (!showJackpots || formFocused || formSubmitted) return;
      setIsMoving(prev => ({ ...prev, infinity: true }));
      const newX = Math.random() * (window.innerWidth - 320);
      const newY = Math.random() * (window.innerHeight - 200);
      setInfinityPos({ left: newX, top: newY, x: newX, y: newY });
      setTimeout(() => setIsMoving(prev => ({ ...prev, infinity: false })), 500);
    };
    
    const moveMagic = () => {
      if (!showJackpots || formFocused || formSubmitted) return;
      setIsMoving(prev => ({ ...prev, magic: true }));
      const newX = Math.random() * (window.innerWidth - 320);
      const newY = Math.random() * (window.innerHeight - 200);
      setMagicPos({ right: 'auto', left: newX, top: newY });
      setTimeout(() => setIsMoving(prev => ({ ...prev, magic: false })), 500);
    };
    
    const moveHappy = () => {
      if (!showJackpots || formFocused || formSubmitted) return;
      setIsMoving(prev => ({ ...prev, happy: true }));
      const newX = Math.random() * (window.innerWidth - 200);
      const newY = Math.random() * (window.innerHeight - 150);
      setHappyPos({ left: newX, top: newY, bottom: 'auto' });
      setTimeout(() => setIsMoving(prev => ({ ...prev, happy: false })), 500);
    };
    
    const infinityMoveInterval = setInterval(moveInfinity, 7000);
    const magicMoveInterval = setInterval(moveMagic, 8000);
    const happyMoveInterval = setInterval(moveHappy, 6000);
    
    return () => {
      clearInterval(infinityMoveInterval);
      clearInterval(magicMoveInterval);
      clearInterval(happyMoveInterval);
    };
  }, [showJackpots, formFocused, formSubmitted]);
  
  // ========== SPIRIDUȘI ==========
  useEffect(() => {
    const generateLeprechaun = () => {
      if (formFocused || formSubmitted) return;
      const corners = [
        { x: 10, y: window.innerHeight - 120 },
        { x: window.innerWidth - 120, y: window.innerHeight - 120 },
        { x: 10, y: 100 },
        { x: window.innerWidth - 120, y: 100 }
      ];
      const corner = corners[Math.floor(Math.random() * corners.length)];
      const rewardAmount = Math.floor(Math.random() * 8000 + 1000);
      
      setLeprechauns(prev => [...prev, {
        id: Math.random(),
        x: corner.x,
        y: corner.y,
        targetX: window.innerWidth / 2 + (Math.random() - 0.5) * 250,
        targetY: window.innerHeight / 2 + (Math.random() - 0.5) * 150,
        reward: rewardAmount,
        progress: 0
      }]);
      
      setTimeout(() => {
        setLeprechauns(prev => prev.filter(l => l.id !== leprechauns[0]?.id));
      }, 6000);
    };
    
    const interval = setInterval(generateLeprechaun, 6000);
    generateLeprechaun();
    return () => clearInterval(interval);
  }, [formFocused, formSubmitted]);
  
  // ========== MIȘCARE SPIRIDUȘI ==========
  useEffect(() => {
    const moveInterval = setInterval(() => {
      if (formFocused || formSubmitted) return;
      setLeprechauns(prev => prev.map(lep => {
        const dx = lep.targetX - lep.x;
        const dy = lep.targetY - lep.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        
        if (distance < 50) {
          setHappyCollected(c => c + lep.reward);
          setCollectedRewards(prev => [...prev, {
            id: Math.random(),
            amount: lep.reward,
            x: lep.x,
            y: lep.y
          }]);
          setTimeout(() => {
            setCollectedRewards(prev => prev.filter(r => r.id !== lep.id));
          }, 1000);
          return null;
        }
        
        const stepX = (dx / distance) * 4;
        const stepY = (dy / distance) * 4;
        const newProgress = ((lep.targetX - lep.x) / lep.targetX) * 100;
        return { ...lep, x: lep.x + stepX, y: lep.y + stepY, progress: Math.min(100, Math.abs(newProgress)) };
      }).filter(Boolean));
    }, 50);
    
    return () => clearInterval(moveInterval);
  }, [formFocused, formSubmitted]);
  
  // ========== SPIRIDUȘ CU PANCARTĂ ==========
  useEffect(() => {
    const signInterval = setInterval(() => {
      if (formFocused || formSubmitted) return;
      const corners = [
        { x: 20, y: window.innerHeight - 250 },
        { x: window.innerWidth - 300, y: window.innerHeight - 250 },
        { x: 20, y: 150 },
        { x: window.innerWidth - 300, y: 150 }
      ];
      const corner = corners[Math.floor(Math.random() * corners.length)];
      setSignLeprechaunPos({ x: corner.x, y: corner.y });
      setShowSignLeprechaun(true);
      setSignLeprechaunScale(1.5);
      
      const growInterval = setInterval(() => {
        if (!showSignLeprechaun) {
          clearInterval(growInterval);
          return;
        }
        setSignLeprechaunScale(prev => Math.min(prev + 0.15, 3.2));
      }, 200);
      
      setTimeout(() => {
        clearInterval(growInterval);
        setShowSignLeprechaun(false);
        setSignLeprechaunScale(1.5);
      }, 15000);
      
      return () => clearInterval(growInterval);
    }, 25000);
    
    return () => clearInterval(signInterval);
  }, [formFocused, formSubmitted, showSignLeprechaun]);
  
  // ========== FUNCȚIE PENTRU CLICK PE FORMULAR ==========
  const toggleFormFocus = () => {
    if (isMobile) {
      setFormFocused(!formFocused);
      if (!formFocused) {
        setShowJackpots(false);
      } else {
        setShowJackpots(true);
      }
    }
  };
  
  // ========== FUNCȚIE PENTRU CLICK LÂNGĂ OFERTĂ ==========
  const handleOutsideClick = (e) => {
    if (formFocused && !e.target.closest('#contact-form-section')) {
      setFormFocused(false);
      setShowJackpots(true);
    }
  };
  
  // ========== FUNCȚIE PENTRU CLICK PE JACKPOT ==========
  const handleJackpotClick = (jackpotType) => {
    setShowJackpots(false);
    setFormFocused(true);
  };
  
  // ========== TRADUCERI ==========
  const translations = {
    ro: {
      saleTitle: "FOST CAZINOU ONLINE DE VÂNZARE",
      contactTitle: "📧 Trimite oferta ta",
      name: "Numele tău *",
      email: "Email *",
      phone: "Telefon",
      price: "Prețul ofertei",
      message: "Mesajul tău *",
      submit: "✉️ Trimite oferta",
      game1Title: "🎰 Royal Slots",
      game1Desc: "Slot regal cu jackpot progresiv și șeptari norocoși.",
      game1Rtp: "📊 RTP: 96.2%",
      game2Title: "🎲 Ruletă Europeană",
      game2Desc: "Ruletă europeană clasică cu un singur zero.",
      game2Rtp: "📊 RTP: 97.3%",
      game3Title: "♠️ Velvet Blackjack",
      game3Desc: "Blackjack 21 — bate dealer-ul cu strategie și noroc.",
      game3Rtp: "📊 RTP: 99.1%",
      langLabel: "RO"
    },
    en: {
      saleTitle: "FORMER ONLINE CASINO FOR SALE",
      contactTitle: "📧 Send your offer",
      name: "Your name *",
      email: "Email *",
      phone: "Phone",
      price: "Offer price",
      message: "Your message *",
      submit: "✉️ Send offer",
      game1Title: "🎰 Royal Slots",
      game1Desc: "Royal slot with progressive jackpot and lucky sevens.",
      game1Rtp: "📊 RTP: 96.2%",
      game2Title: "🎲 European Roulette",
      game2Desc: "Classic European roulette with single zero.",
      game2Rtp: "📊 RTP: 97.3%",
      game3Title: "♠️ Velvet Blackjack",
      game3Desc: "Blackjack 21 — beat the dealer with strategy and luck.",
      game3Rtp: "📊 RTP: 99.1%",
      langLabel: "EN",
      audioMessage: "Magic Games. This domain is for sale. For offers, please contact the owner."
    },
    de: {
      saleTitle: "EHEMALIGES ONLINE-CASINO ZU VERKAUFEN",
      contactTitle: "📧 Angebot senden",
      name: "Ihr Name *",
      email: "E-Mail *",
      phone: "Telefon",
      price: "Angebotspreis",
      message: "Ihre Nachricht *",
      submit: "✉️ Angebot senden",
      game1Title: "🎰 Royal Slots",
      game1Desc: "Royal Slot mit progressivem Jackpot.",
      game1Rtp: "📊 RTP: 96.2%",
      game2Title: "🎲 Europäisches Roulette",
      game2Desc: "Klassisches europäisches Roulette.",
      game2Rtp: "📊 RTP: 97.3%",
      game3Title: "♠️ Velvet Blackjack",
      game3Desc: "Blackjack 21 — den Dealer schlagen.",
      game3Rtp: "📊 RTP: 99.1%",
      langLabel: "DE",
      audioMessage: "Magic Games. Diese Domain steht zum Verkauf. Für Angebote kontaktieren Sie den Eigentümer."
    },
    fr: {
      saleTitle: "ANCIEN CASINO EN LIGNE À VENDRE",
      contactTitle: "📧 Envoyer votre offre",
      name: "Votre nom *",
      email: "Email *",
      phone: "Téléphone",
      price: "Prix de l'offre",
      message: "Votre message *",
      submit: "✉️ Envoyer l'offre",
      game1Title: "🎰 Royal Slots",
      game1Desc: "Slot royal avec jackpot progressif.",
      game1Rtp: "📊 RTP: 96.2%",
      game2Title: "🎲 Roulette Européenne",
      game2Desc: "Roulette européenne classique.",
      game2Rtp: "📊 RTP: 97.3%",
      game3Title: "♠️ Velvet Blackjack",
      game3Desc: "Blackjack 21 — battez le croupier.",
      game3Rtp: "📊 RTP: 99.1%",
      langLabel: "FR",
      audioMessage: "Magic Games. Ce domaine est à vendre. Pour les offres, contactez le propriétaire."
    },
    it: {
      saleTitle: "EX CASINÒ ONLINE IN VENDITA",
      contactTitle: "📧 Invia la tua offerta",
      name: "Il tuo nome *",
      email: "Email *",
      phone: "Telefono",
      price: "Prezzo dell'offerta",
      message: "Il tuo messaggio *",
      submit: "✉️ Invia offerta",
      game1Title: "🎰 Royal Slots",
      game1Desc: "Slot reale con jackpot progressivo.",
      game1Rtp: "📊 RTP: 96.2%",
      game2Title: "🎲 Roulette Europea",
      game2Desc: "Roulette europea classica.",
      game2Rtp: "📊 RTP: 97.3%",
      game3Title: "♠️ Velvet Blackjack",
      game3Desc: "Blackjack 21 — batti il banco.",
      game3Rtp: "📊 RTP: 99.1%",
      langLabel: "IT",
      audioMessage: "Magic Games. Questo dominio è in vendita. Per offerte, contatta il proprietario."
    }
  };

  const t = translations[currentLang];
  
  const formatMoney = (amount) => Math.floor(amount).toLocaleString('ro-RO') + ' RON';
  const infinityPercent = (infinityAmount / targetAmount) * 100;
  const magicPercent = (magicAmount / targetAmount) * 100;
  const happyPercent = (happyAmount / targetAmount) * 100;
  
  // Sunet
  const speakMessage = () => {
    if (currentLang === 'ro') return;
    if (window.speechSynthesis.speaking) {
      window.speechSynthesis.cancel();
      setIsPlaying(false);
      return;
    }
    const utterance = new SpeechSynthesisUtterance(t.audioMessage);
    const langMap = { en: 'en-US', de: 'de-DE', fr: 'fr-FR', it: 'it-IT' };
    utterance.lang = langMap[currentLang];
    utterance.rate = 0.9;
    utterance.onstart = () => setIsPlaying(true);
    utterance.onend = () => {
      setIsPlaying(false);
      setSoundPlayed(true);
    };
    window.speechSynthesis.speak(utterance);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formMessage = document.getElementById('formMessage');
    const submitBtn = document.getElementById('submitBtn');
    submitBtn.disabled = true;
    submitBtn.textContent = t.submit === "✉️ Trimite oferta" ? "Se trimite..." : "Sending...";
    
    setFormSubmitted(true);
    setFormFocused(false);
    
    const formData = {
      name: e.target.name.value,
      email: e.target.email.value,
      phone: e.target.phone.value || '',
      currency: e.target.currency.value,
      price: e.target.price.value || '0',
      message: e.target.message.value
    };
    
    try {
      const response = await fetch('/api/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const result = await response.json();
      if (result.success) {
        formMessage.innerHTML = '✅ ' + result.message;
        formMessage.style.color = '#90EE90';
        e.target.reset();
        setTimeout(() => {
          setFormSubmitted(false);
          setShowJackpots(true);
        }, 3000);
      } else {
        formMessage.innerHTML = '❌ ' + result.message;
        formMessage.style.color = '#FF8888';
        setFormSubmitted(false);
        setShowJackpots(true);
      }
    } catch (error) {
      formMessage.innerHTML = '❌ Eroare de conexiune. Încearcă din nou.';
      formMessage.style.color = '#FF8888';
      setFormSubmitted(false);
      setShowJackpots(true);
    }
    setTimeout(() => { formMessage.innerHTML = ''; }, 5000);
    submitBtn.disabled = false;
    submitBtn.textContent = t.submit;
  };
  
  const handleVideoClick = (videoId) => {
    setActiveVideo(null);
  };
  
  const handleVideoEnded = () => {
    setActiveVideo(null);
  };
  
  // Verifică dacă totul trebuie ascuns
  const shouldHideEverything = (formFocused || formSubmitted) && isMobile;
  
  return (
    <>
      {/* FUNDAL */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: 'url(/images/casino-bg.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        zIndex: 0
      }} />
      
      {/* MESAJ CÂȘTIG JACKPOT CU NUME */}
      {!shouldHideEverything && showJackpotWin && (
        <div style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1000,
          background: 'rgba(0,0,0,0.85)',
          backdropFilter: 'blur(10px)',
          borderRadius: '30px',
          padding: '30px 50px',
          textAlign: 'center',
          animation: 'winPop 0.5s ease-out',
          boxShadow: '0 0 50px rgba(255,215,0,0.6)',
          border: '2px solid rgba(255,215,0,0.5)'
        }}>
          <div style={{ fontSize: '2em', fontWeight: 'bold', color: '#FFD700', marginBottom: '15px' }}>🎉 JACKPOT CÂȘTIGĂTOR! 🎉</div>
          <div style={{ fontSize: '1.3em', fontWeight: 'bold', color: '#FFA500', marginBottom: '10px' }}>{showJackpotWin.name}</div>
          <div style={{ fontSize: '1.5em', fontWeight: 'bold', color: '#FFD700' }}>Ai câștigat {formatMoney(showJackpotWin.amount)}!</div>
        </div>
      )}
      
      {/* TITLU CU FOC */}
      {!shouldHideEverything && (
        <div style={{
          position: 'fixed',
          top: '20px',
          left: 0,
          right: 0,
          textAlign: 'center',
          zIndex: 100,
          animation: 'titleShake 0.5s ease-in-out infinite'
        }}>
          <div style={{
            position: 'absolute',
            top: -30,
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#FF4500',
            textShadow: '0 0 10px red',
            animation: 'flameUp 0.5s infinite',
            whiteSpace: 'nowrap'
          }}>🔥 HOT 🔥</div>
          
          <div style={{
            display: 'inline-block',
            background: 'rgba(0,0,0,0.8)',
            border: '2px solid #FFD700',
            borderRadius: '50px',
            padding: '12px 30px',
            animation: 'titlePulse 2s infinite, titleTremble 0.1s infinite'
          }}>
            <span style={{
              fontSize: 'clamp(16px, 5vw, 28px)',
              fontWeight: 'bold',
              background: 'linear-gradient(135deg, #FFD700, #FFA500, #FF4500)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent',
              animation: 'textShine 1s infinite'
            }}>{t.saleTitle}</span>
          </div>
          
          <div style={{
            position: 'absolute',
            bottom: -30,
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#FF4500',
            textShadow: '0 0 10px red',
            animation: 'flameDown 0.5s infinite',
            whiteSpace: 'nowrap'
          }}>🔥 HOT 🔥</div>
        </div>
      )}
      
      {/* JACKPOTURI CARE SE PLIMBĂ */}
      {!shouldHideEverything && showJackpots && (
        <>
          {/* INFINITY JACKPOT */}
          <div style={{
            position: 'fixed',
            left: infinityPos.left,
            top: infinityPos.top,
            transform: 'translateY(-50%)',
            zIndex: 100,
            cursor: 'pointer',
            width: isMobile ? '130px' : '300px',
            background: 'linear-gradient(180deg, #87CEEB 0%, #B0E0E6 50%, #E0F7FF 100%)',
            borderRadius: '20px',
            padding: isMobile ? '10px' : '20px',
            border: '2px solid #00BFFF',
            boxShadow: '0 0 20px rgba(0,150,255,0.4)',
            transition: 'all 0.5s ease',
            animation: isMoving.infinity ? 'movePulse 0.5s ease' : 'none'
          }} onClick={() => handleJackpotClick('infinity')}>
            <div style={{
              width: '100%',
              height: isMobile ? '60px' : '100px',
              borderRadius: '10px',
              overflow: 'hidden',
              marginBottom: '10px',
              border: '1px solid #00BFFF'
            }}>
              <video autoPlay loop muted playsInline style={{ width: '100%', height: '100%', objectFit: 'cover' }}>
                <source src="/videos/jackpot.mp4" type="video/mp4" />
              </video>
            </div>
            <div style={{ fontSize: isMobile ? '0.6em' : '1.1em', fontWeight: 'bold', color: '#0066cc', textAlign: 'center', marginBottom: '5px' }}>🌊 INFINITY</div>
            <div style={{ fontSize: isMobile ? '0.8em' : '1.4em', fontWeight: 'bold', color: '#FFD700', textAlign: 'center' }}>{isMobile ? formatMoney(infinityAmount).substring(0, 8) : formatMoney(infinityAmount)}</div>
          </div>
          
          {/* MAGIC GOLD JACKPOT */}
          <div style={{
            position: 'fixed',
            left: magicPos.left,
            top: magicPos.top,
            transform: 'translateY(-50%)',
            zIndex: 100,
            cursor: 'pointer',
            width: isMobile ? '130px' : '300px',
            background: 'linear-gradient(135deg, #FFD700, #FFA500, #B8860B, #DAA520)',
            borderRadius: '20px',
            padding: isMobile ? '10px' : '20px',
            border: '2px solid #FF4500',
            boxShadow: '0 0 30px rgba(255,69,0,0.5)',
            animation: `${isMoving.magic ? 'movePulse 0.5s ease, ' : ''}goldBorder 2s infinite`,
            transition: 'all 0.5s ease'
          }} onClick={() => handleJackpotClick('magic')}>
            <div style={{
              width: '100%',
              height: isMobile ? '60px' : '100px',
              borderRadius: '10px',
              overflow: 'hidden',
              marginBottom: '10px',
              border: '1px solid #FFD700'
            }}>
              <video autoPlay loop muted playsInline style={{ width: '100%', height: '100%', objectFit: 'cover' }}>
                <source src="/videos/gold.mp4" type="video/mp4" />
              </video>
            </div>
            <div style={{ fontSize: isMobile ? '0.55em' : '1.1em', fontWeight: 'bold', background: 'linear-gradient(135deg, #FF0000, #FF4500)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent', textAlign: 'center', marginBottom: '5px', animation: 'flameText 1s infinite' }}>🔥 MAGIC GOLD</div>
            <div style={{ fontSize: isMobile ? '0.8em' : '1.4em', fontWeight: 'bold', color: '#FFF8DC', textAlign: 'center' }}>{isMobile ? formatMoney(magicAmount).substring(0, 8) : formatMoney(magicAmount)}</div>
          </div>
          
          {/* HAPPY HOUR JACKPOT */}
          <div style={{
            position: 'fixed',
            left: happyPos.left,
            top: happyPos.top,
            zIndex: 100,
            cursor: 'pointer',
            background: 'linear-gradient(135deg, #FF69B4, #FF1493)',
            border: '2px solid #FFD700',
            borderRadius: '15px',
            padding: isMobile ? '8px 12px' : '12px 20px',
            minWidth: isMobile ? '100px' : '180px',
            textAlign: 'center',
            animation: isMoving.happy ? 'movePulse 0.5s ease' : 'pulse 2s infinite',
            transition: 'all 0.5s ease',
            boxShadow: '0 0 20px rgba(255,105,180,0.5)'
          }} onClick={() => handleJackpotClick('happy')}>
            <div style={{ fontSize: isMobile ? '0.7em' : '0.9em', fontWeight: 'bold', color: '#FFD700' }}>🎉 HAPPY HOUR</div>
            <div style={{ fontSize: isMobile ? '0.8em' : '1.2em', fontWeight: 'bold', color: '#FFD700' }}>{isMobile ? formatMoney(happyAmount).substring(0, 8) : formatMoney(happyAmount)}</div>
          </div>
        </>
      )}
      
      {/* SPIRIDUȘI */}
      {!shouldHideEverything && leprechauns.map(lep => (
        <div key={lep.id} style={{
          position: 'fixed',
          left: lep.x,
          top: lep.y,
          zIndex: 200,
          transition: 'all 0.03s linear',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: isMobile ? '60px' : '90px'
        }}>
          <video autoPlay loop muted playsInline style={{
            width: isMobile ? '50px' : '80px',
            height: isMobile ? '50px' : '80px',
            borderRadius: '50%',
            border: '2px solid #FFD700'
          }}>
            <source src="/videos/leprechaun.mp4" type="video/mp4" />
          </video>
          <div style={{
            background: 'rgba(0,0,0,0.7)',
            color: '#FFD700',
            padding: '2px 5px',
            borderRadius: '8px',
            fontSize: isMobile ? '8px' : '11px',
            marginTop: '3px'
          }}>🎁 +{lep.reward} RON</div>
        </div>
      ))}
      
      {/* SPIRIDUȘ CU PANCARTĂ */}
      {!shouldHideEverything && showSignLeprechaun && (
        <div onClick={() => {
          toggleFormFocus();
          setShowSignLeprechaun(false);
        }} style={{
          position: 'fixed',
          left: signLeprechaunPos.x,
          top: signLeprechaunPos.y,
          zIndex: 201,
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          animation: 'bounce 0.5s infinite',
          transform: `scale(${signLeprechaunScale})`,
          transformOrigin: 'center center',
          transition: 'transform 0.2s ease-out'
        }}>
          <video autoPlay loop muted playsInline style={{
            width: isMobile ? '120px' : '160px',
            height: isMobile ? '120px' : '160px',
            borderRadius: '50%',
            border: '4px solid #FFD700',
            boxShadow: '0 0 40px rgba(0,255,0,0.8)'
          }}>
            <source src="/videos/leprechaun.mp4" type="video/mp4" />
          </video>
          <div style={{
            background: 'linear-gradient(135deg, #FFD700, #FFA500)',
            color: '#000',
            padding: isMobile ? '15px 25px' : '20px 40px',
            borderRadius: '25px',
            fontSize: isMobile ? '22px' : '32px',
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
            marginTop: '15px',
            border: '3px solid red',
            animation: 'pulse 1s infinite'
          }}>
            📝 FA O OFERTĂ!
          </div>
        </div>
      )}
      
      {/* BUTON LIMBĂ + SUNET */}
      {!shouldHideEverything && (
        <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 101, display: 'flex', gap: '10px' }}>
          <div style={{ position: 'relative' }}>
            <button onClick={() => setShowLangDropdown(!showLangDropdown)} style={{
              background: 'linear-gradient(135deg, #FFD700, #FFA500)',
              border: 'none',
              borderRadius: '30px',
              padding: '8px 16px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}>
              🌐 {t.langLabel} ▼
            </button>
            {showLangDropdown && (
              <div style={{
                position: 'absolute',
                bottom: '45px',
                right: 0,
                background: 'rgba(0,0,0,0.95)',
                border: '1px solid #FFD700',
                borderRadius: '10px',
                padding: '8px'
              }}>
                {['en', 'de', 'fr', 'it'].map(lang => (
                  <button key={lang} onClick={() => { setCurrentLang(lang); setShowLangDropdown(false); }} style={{
                    display: 'block',
                    width: '100%',
                    background: 'transparent',
                    border: 'none',
                    color: '#FFD700',
                    padding: '8px 15px',
                    cursor: 'pointer'
                  }}>
                    {lang === 'en' && '🇬🇧 English'}
                    {lang === 'de' && '🇩🇪 Deutsch'}
                    {lang === 'fr' && '🇫🇷 Français'}
                    {lang === 'it' && '🇮🇹 Italiano'}
                  </button>
                ))}
              </div>
            )}
          </div>
          
          {currentLang !== 'ro' && (
            <button onClick={speakMessage} style={{
              background: isPlaying ? 'linear-gradient(135deg, #FF4500, #FF6347)' : 'linear-gradient(135deg, #FFD700, #FFA500)',
              border: 'none',
              borderRadius: '30px',
              padding: '8px 16px',
              cursor: 'pointer',
              fontWeight: 'bold',
              color: isPlaying ? '#fff' : '#000'
            }}>
              🔊 {isPlaying ? 'Playing...' : (soundPlayed ? 'Replay' : 'Listen')}
            </button>
          )}
        </div>
      )}
      
      {/* VIDEOURI JOS - CU PREVIEW ȘI DIMENSIUNI MAI MARI */}
      {!shouldHideEverything && (
        <div style={{
          position: 'fixed',
          bottom: '20px',
          left: 0,
          right: 0,
          display: 'flex',
          justifyContent: 'center',
          gap: '15px',
          flexWrap: 'wrap',
          zIndex: 15,
          padding: '0 20px'
        }}>
          {[1, 2, 3, 4].map(num => {
            const isActive = activeVideo === num;
            const videoUrl = `${window.location.origin}/videos/vide${num}.mp4`;
            return (
              <div 
                key={num} 
                onClick={() => handleVideoClick(num)}
                style={{
                  width: isMobile ? (isActive ? '200px' : '80px') : (isActive ? '280px' : '120px'),
                  height: isMobile ? (isActive ? '150px' : '80px') : (isActive ? '200px' : '120px'),
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: isActive ? '3px solid #FF4500' : '2px solid #FFD700',
                  background: '#000',
                  boxShadow: isActive ? '0 0 30px rgba(255,69,0,0.8)' : '0 0 10px rgba(255,215,0,0.3)',
                  cursor: 'pointer',
                  transition: 'all 0.5s ease-in-out',
                  transform: isActive ? 'translateY(-180px) scale(1.3)' : 'translateY(0) scale(1)',
                  zIndex: isActive ? 20 : 1,
                  position: 'relative'
                }}
              >
                <video 
                  autoPlay={isActive}
                  loop={!isActive}
                  muted 
                  playsInline 
                  style={{ 
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover'
                  }}
                  onEnded={handleVideoEnded}
                >
                  <source src={videoUrl} type="video/mp4" />
                </video>
                {!isActive && (
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                    padding: '8px',
                    textAlign: 'center',
                    fontSize: isMobile ? '10px' : '12px',
                    fontWeight: 'bold',
                    color: '#FFD700'
                  }}>
                    {num === 1 && '🎰 SLOT'}
                    {num === 2 && '🎲 ROULETTE'}
                    {num === 3 && '♠️ BLACKJACK'}
                    {num === 4 && '💰 JACKPOT'}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
      
      {/* MAIN CONTENT - FORMULAR */}
      <div id="contact-form-section" style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: shouldHideEverything ? '100px 20px' : (isMobile ? '350px 15px 180px 15px' : '280px 20px 200px 20px'),
        display: 'flex',
        flexWrap: 'wrap',
        gap: '30px',
        position: 'relative',
        zIndex: 10
      }} onClick={handleOutsideClick}>
        {/* FORMULAR */}
        <div style={{
          flex: shouldHideEverything ? 'none' : 1,
          width: shouldHideEverything ? '100%' : 'auto',
          maxWidth: shouldHideEverything ? '500px' : 'none',
          margin: shouldHideEverything ? '0 auto' : '0',
          minWidth: '280px',
          transition: 'all 0.5s ease'
        }}>
          <div style={{
            background: 'rgba(0,0,0,0.85)',
            borderRadius: '20px',
            padding: '30px',
            border: formFocused ? '3px solid #FFD700' : '2px solid rgba(255,215,0,0.5)',
            backdropFilter: 'blur(10px)',
            boxShadow: formFocused ? '0 0 40px rgba(255,215,0,0.5)' : '0 0 20px rgba(255,215,0,0.2)'
          }}>
            <h2 style={{ fontSize: '1.5em', color: '#FFD700', marginBottom: '25px', textAlign: 'center' }}>{t.contactTitle}</h2>
            <form onSubmit={handleSubmit}>
              <input 
                type="text" 
                name="name" 
                placeholder={t.name} 
                required 
                style={{ width: '100%', padding: '12px', marginBottom: '15px', background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,215,0,0.3)', borderRadius: '10px', color: 'white' }} 
              />
              <input 
                type="email" 
                name="email" 
                placeholder={t.email} 
                required 
                style={{ width: '100%', padding: '12px', marginBottom: '15px', background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,215,0,0.3)', borderRadius: '10px', color: 'white' }} 
              />
              <input 
                type="tel" 
                name="phone" 
                placeholder={t.phone} 
                style={{ width: '100%', padding: '12px', marginBottom: '15px', background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,215,0,0.3)', borderRadius: '10px', color: 'white' }} 
              />
              
              <select 
                name="currency" 
                style={{ width: '100%', padding: '12px', marginBottom: '15px', background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,215,0,0.3)', borderRadius: '10px', color: 'white' }}
              >
                <option value="EUR">💶 Euro (EUR)</option>
                <option value="USD">💵 Dollar (USD)</option>
                <option value="RON">🇷🇴 Leu (RON)</option>
                <option value="BTC">₿ Bitcoin (BTC)</option>
                <option value="ETH">⟠ Ethereum (ETH)</option>
                <option value="GOLD">🪙 Gold (XAU)</option>
              </select>
              
              <input 
                type="text" 
                name="price" 
                placeholder={t.price} 
                style={{ width: '100%', padding: '12px', marginBottom: '15px', background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,215,0,0.3)', borderRadius: '10px', color: 'white' }} 
              />
              <textarea 
                name="message" 
                placeholder={t.message} 
                required 
                rows="4" 
                style={{ width: '100%', padding: '12px', marginBottom: '15px', background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,215,0,0.3)', borderRadius: '10px', color: 'white', resize: 'vertical' }}
              ></textarea>
              <button type="submit" id="submitBtn" style={{
                width: '100%',
                padding: '14px',
                background: 'linear-gradient(135deg, #FFD700, #FFA500)',
                border: 'none',
                borderRadius: '10px',
                fontWeight: 'bold',
                fontSize: '1.1em',
                cursor: 'pointer',
                animation: 'buttonShake 0.3s ease-in-out infinite'
              }}>{t.submit}</button>
              <div id="formMessage" style={{ marginTop: '15px', textAlign: 'center', fontSize: '0.8em', color: '#FFD700' }}></div>
            </form>
            
            {formFocused && isMobile && (
              <button onClick={toggleFormFocus} style={{
                marginTop: '15px',
                width: '100%',
                padding: '10px',
                background: 'rgba(255,255,255,0.2)',
                border: '1px solid #FFD700',
                borderRadius: '10px',
                color: '#FFD700',
                cursor: 'pointer'
              }}>
                ← Înapoi la jocuri
              </button>
            )}
          </div>
        </div>
        
        {/* JOCURI */}
        {!shouldHideEverything && (
          <div style={{ flex: 1, minWidth: '280px' }}>
            <div style={{ background: 'rgba(0,0,0,0.75)', borderRadius: '20px', padding: '25px', marginBottom: '20px', border: '1px solid rgba(255,215,0,0.3)', animation: 'gameRotate 3s ease-in-out infinite' }}>
              <div style={{ fontSize: '1.3em', fontWeight: 'bold', color: '#FFD700', marginBottom: '10px' }}>{t.game1Title}</div>
              <div style={{ color: '#ccc', marginBottom: '15px', fontSize: '0.9em' }}>{t.game1Desc}</div>
              <div style={{ color: '#FFA500', fontSize: '0.8em', fontWeight: 'bold' }}>{t.game1Rtp}</div>
            </div>
            <div style={{ background: 'rgba(0,0,0,0.75)', borderRadius: '20px', padding: '25px', marginBottom: '20px', border: '1px solid rgba(255,215,0,0.3)', animation: 'gameRotate 3s ease-in-out infinite 1s' }}>
              <div style={{ fontSize: '1.3em', fontWeight: 'bold', color: '#FFD700', marginBottom: '10px' }}>{t.game2Title}</div>
              <div style={{ color: '#ccc', marginBottom: '15px', fontSize: '0.9em' }}>{t.game2Desc}</div>
              <div style={{ color: '#FFA500', fontSize: '0.8em', fontWeight: 'bold' }}>{t.game2Rtp}</div>
            </div>
            <div style={{ background: 'rgba(0,0,0,0.75)', borderRadius: '20px', padding: '25px', marginBottom: '20px', border: '1px solid rgba(255,215,0,0.3)', animation: 'gameRotate 3s ease-in-out infinite 2s' }}>
              <div style={{ fontSize: '1.3em', fontWeight: 'bold', color: '#FFD700', marginBottom: '10px' }}>{t.game3Title}</div>
              <div style={{ color: '#ccc', marginBottom: '15px', fontSize: '0.9em' }}>{t.game3Desc}</div>
              <div style={{ color: '#FFA500', fontSize: '0.8em', fontWeight: 'bold' }}>{t.game3Rtp}</div>
            </div>
          </div>
        )}
      </div>
      
      {/* ========== SEO CONTENT - ASCUNS VIZUAL DAR VIZIBIL PENTRU MOTOARELE DE CĂUTARE ========== */}
      <div style={{ 
        position: 'absolute', 
        width: '1px', 
        height: '1px', 
        padding: 0, 
        margin: '-1px', 
        overflow: 'hidden',
        clip: 'rect(0,0,0,0)',
        border: 0,
        whiteSpace: 'nowrap'
      }}>
        <h1>Magic Games - Fost Cazinou Online de Vânzare</h1>
        <p>Magic Games a fost un cazinou online de succes cu tradiție îndelungată în industria jocurilor de noroc online din România. Acum domeniul magicgames.ro este disponibil pentru vânzare. O oportunitate unică pentru investitori în domeniul cazinourilor online.</p>
        <p>Domeniul premium are o autoritate solidă în domeniul jocurilor de noroc online și este recunoscut de jucători. Domeniul include istoric, trafic și brand cunoscut.</p>
        
        <h2>De ce să cumperi domeniul Magic Games?</h2>
        <ul>
          <li>Domeniu premium cu istoric și tradiție în casino online</li>
          <li>Brand recunoscut în industria cazinourilor online</li>
          <li>Trafic organic și autoritate în domeniul jocurilor de noroc</li>
          <li>Posibilitate de dezvoltare imediată a unui nou casino online</li>
          <li>Domeniu .ro cu relevanță pe piața românească</li>
        </ul>
        
        <h2>Cryptocurrency & Online Casino Domain</h2>
        <p>Magic Games is a premium online casino domain with history and tradition in the gambling industry. The domain is now for sale. Accepting offers in EUR, USD, BTC, ETH, USDT.</p>
        <p>This former online casino domain has established authority and brand recognition. Perfect opportunity for investors in the iGaming industry.</p>
        
        <h2>Contactează proprietarul pentru ofertă</h2>
        <p>Pentru a face o ofertă pentru domeniul magicgames.ro, completează formularul de contact de pe această pagină. Acceptăm oferte în valută și criptomonede.</p>
      </div>
      
      <style>{`
        @keyframes titlePulse {
          0%, 100% { box-shadow: 0 0 20px rgba(255,215,0,0.3); }
          50% { box-shadow: 0 0 40px rgba(255,215,0,0.6); }
        }
        @keyframes titleShake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-3px); }
          75% { transform: translateX(3px); }
        }
        @keyframes titleTremble {
          0%, 100% { transform: translateY(0); }
          25% { transform: translateY(-2px); }
          75% { transform: translateY(2px); }
        }
        @keyframes buttonShake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-2px); }
          75% { transform: translateX(2px); }
        }
        @keyframes gameRotate {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(0.5deg); }
          75% { transform: rotate(-0.5deg); }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.02); }
        }
        @keyframes movePulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.05); }
          100% { transform: scale(1); }
        }
        @keyframes goldBorder {
          0%, 100% { border-color: #FFD700; box-shadow: 0 0 20px rgba(255,215,0,0.4); }
          50% { border-color: #FF4500; box-shadow: 0 0 30px rgba(255,69,0,0.6); }
        }
        @keyframes flameText {
          0%, 100% { text-shadow: 0 0 5px red, 0 0 10px orange; }
          50% { text-shadow: 0 0 15px red, 0 0 25px orange; }
        }
        @keyframes flameUp {
          0%, 100% { transform: translateX(-50%) translateY(0); opacity: 0.8; }
          50% { transform: translateX(-50%) translateY(-5px); opacity: 1; }
        }
        @keyframes flameDown {
          0%, 100% { transform: translateX(-50%) translateY(0); opacity: 0.8; }
          50% { transform: translateX(-50%) translateY(5px); opacity: 1; }
        }
        @keyframes textShine {
          0%, 100% { filter: brightness(1); }
          50% { filter: brightness(1.2); }
        }
        @keyframes winPop {
          0% { transform: translate(-50%, -50%) scale(0); opacity: 0; }
          100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
        }
      `}</style>
    </>
  );
}

export default App;